import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=b36dbb32&"
import script from "./InvoiceCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports